class placeOrderImage {
  constructor(config = {}) {
    const {image, parents, container, breakpoint, isPDF} = config;

    this.breakpoint = breakpoint;
    this.isPDF = isPDF || false

    this.parents = document.querySelectorAll(parents);
    this.parentsArray = Array.prototype.slice.call(this.parents);
    this.container = container;

    this.image = image;

    if(this.checkScreenSize() || this.isPDF){
        this.bindEvents();
    }

    window.addEventListener('resize', () => {
      if(this.checkScreenSize()){
        this.bindEvents();
      }
    });
  }

  bindEvents() {
      this.parentsArray.forEach((item)=>{
        let firstImage = item.querySelector(this.image);
        let container = item.querySelector(this.container);
        let theFirstChild = container.firstChild;
        if(firstImage){
          container.insertBefore(firstImage, theFirstChild);
        }
      });
  }

  checkScreenSize(){
    if(!this.isPDF){
      if(this.parents && this.parents.length !== 0 && window.matchMedia('(' + this.breakpoint + ')').matches){
        return true;
      }
      return false;
    }
  }
}


export default placeOrderImage;
